import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {UserProvider} from './context/UserContext';
import reportWebVitals from './reportWebVitals';
import { ApolloClient, InMemoryCache, ApolloProvider, gql } from '@apollo/client';


const client = new ApolloClient({
  uri: 'http://212.68.57.195:8080/v1/graphql',
  cache: new InMemoryCache(),
});

<head>
    ...
    ...
    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
    <title>Turkish Riviera Homes CRM</title>
    ...
    ...
</head>



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  
 
  
  <ApolloProvider client={client}>
    <UserProvider>
       <App />
    </UserProvider>
   
    </ApolloProvider>,
   
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
